import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MostPopularCourses from "./../../../assets/images/profileImage.jpg";
import { MdOutlineLocationOn } from "react-icons/md";
import { Button } from "@mui/material";
import {
  MostPopularCoursesNavbar,
  BackHeader,
  SideMenu,
} from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let MostPopularCoursesPage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location);
  let CardData = [
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },

    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
    {
      title: "Lorem ipsum dolor sit a...",
    },
  ];
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Most Popular Courses</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <div className="card-main">
                        <img src={MostPopularCourses} className="card-image" />
                        <p className="card-heading">{v.title}</p>
                        <div className="card-location-main">
                          <MdOutlineLocationOn color="#663399" />

                          <p className="card-location">burnside</p>
                        </div>
                        <div className="card-bottom-main">
                          <Button className="card-price-button" variant="text">
                            $20.00
                          </Button>
                          <Button
                            className="card-right-view-details-button"
                            variant="text"
                            onClick={() => {
                              navigate("/most-popular-courses/details", {
                                state: { type: location.state.type },
                              });
                            }}
                          >
                            View detail
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </div>
      ) : (
        <SideMenu>
          <div className="card-data-main" id="coursesSection">
            <BackHeader backHanler={() => navigate(-1)} />
            <div className="card-header-main">
              <h1 className="card-header-heading">Most Popular Courses</h1>
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {CardData.map((v, i) => {
                  return (
                    <Grid item xl={3} lg={3} md={6} sm={6} xs={12} key={i}>
                      <div className="card-main">
                        <img src={MostPopularCourses} className="card-image" />
                        <p className="card-heading">{v.title}</p>
                        <div className="card-location-main">
                          <MdOutlineLocationOn color="#663399" />

                          <p className="card-location">burnside</p>
                        </div>
                        <div className="card-bottom-main">
                          <Button className="card-price-button" variant="text">
                            $20.00
                          </Button>
                          <Button
                            className="card-right-view-details-button"
                            variant="text"
                            onClick={() => {
                              navigate("/most-popular-courses/details", {
                                state: { type: location.state.type },
                              });
                            }}
                          >
                            View detail
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <br />
          </div>
        </SideMenu>
      )}
    </div>
  );
};
export default MostPopularCoursesPage;
